import { useDispatch } from "react-redux";
import React, { useState } from "react";
import {
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";

import { useAxios } from "../../../hooks";
import { TextField } from "../../../components";
import { TextFifteenYellow, colors } from "../../css components/Style";
import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { alert } from "../../../redux/slices/alertSlice";
import { Link } from "react-router-dom";

export default function VerifyOTPDialog({
  verifyOTP,
  setVerifyOTP,
  formikProps,
  brandID,
  agencyID,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    resend: false,
    verify: false,
  });

  const handleClose = () => {
    formikProps.setValues({
      ...formikProps.values,
      otp: "",
    });
    setVerifyOTP(false);
  };

  return (
    <MUIDialog
      open={verifyOTP}
      onClose={handleClose}
      PaperProps={{
        sx: {
          minWidth: "400px",
          borderRadius: "12px",
        },
      }}
    >
      <DialogContent>
        <Grid container spacing={3}>
          <Grid size={12} textAlign="center">
            <TextFifteenYellow sx={{ color: colors.publicisBlue }}>
              Verify OTP
            </TextFifteenYellow>
          </Grid>

          <Grid size={12}>
            <TextField
              formikProps={formikProps}
              type="number"
              name="otp"
              size="small"
              label="Enter OTP"
              placeholder="Enter OTP"
            />
          </Grid>

          <Grid size={6}>
            <Typography>
              OTP sent on Mobile No: {formikProps.values.companyContact}
            </Typography>
          </Grid>

          <Grid size={6} textAlign="end">
            <Link
              style={{
                textDecoration: "none",
                color: loading.resend ? "#808080" : colors.publicisBlue,
                pointerEvents: loading.resend ? "none" : "auto",
              }}
            >
              <Typography onClick={resendOTP} autoFocus>
                Resend OTP
              </Typography>
            </Link>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <CancelButton onClick={handleClose} variant="outlined">
              Cancel
            </CancelButton>
          </Grid>

          <Grid item>
            <PrimaryLoadingButton
              loading={loading.verify}
              variant="contained"
              disabled={!formikProps.values.otp}
              onClick={verificationOTP}
            >
              Verify OTP
            </PrimaryLoadingButton>
          </Grid>
        </Grid>
      </DialogActions>
    </MUIDialog>
  );

  function verificationOTP() {
    setLoading((prev) => ({ ...prev, verify: true }));
    axios({
      url: "/verify/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        mobile_number: formikProps.values.companyContact,
        msg_type: "registration",
        otp: formikProps.values.otp,
        ...(!!brandID && { brand_id: parseInt(brandID) }),
        ...(!!agencyID && { agency_id: parseInt(agencyID) }),
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          verifyNumber: true,
          otp: "",
        }));

        dispatch(
          alert({
            type: "success",
            message: "Phone Number Verified Successfully",
          })
        );
        setVerifyOTP(false);
      }
      setLoading((prev) => ({ ...prev, verify: false }));
    });
  }

  function resendOTP() {
    setLoading((prev) => ({ ...prev, resend: true }));

    axios({
      url: "/send/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        mobile_number: formikProps.values.companyContact,
        msg_type: "registration",
        resend: true,
        brand_id: parseInt(brandID),
      },
    }).then((response) => {
      if (response.status) {
        dispatch(
          alert({
            type: "success",
            message: "OTP sent successfully",
          })
        );
      }
      setLoading((prev) => ({ ...prev, resend: false }));
    });
  }
}
